module.exports = __webpack_public_path__ + "img/解决方案_节能_白.4306391e.svg";